import React, { useState } from 'react';
import {
  Box,
  Toolbar,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Link
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import axios from "axios";
import { useMode } from "../context/modeContext";

const Pform = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const { mode } = useMode();

  const receivedNumber = location.state?.number || '';

  const [formData, setFormData] = useState({
    name: '',
    mobile: receivedNumber,
    dob: '',
    age: '',
    gender: 'female',
    locationValue: '',
    village: '',
    district: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'dob') {
      const birthDate = new Date(value);
      const today = new Date();

      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      setFormData({
        ...formData,
        dob: value,
        age: age >= 0 ? age : ''
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <Box>
      <Toolbar>
        <div className='diclaimer-Screen'>
          <div className='formrapper'>
            <form onSubmit={handleSubmit}>
              <h2>{t("p_title")}</h2>

              {/* Mobile */}
              <div className='form-lable-input'>
                <label>{t("p_mob")}</label>
                <input
                  type="text"
                  name="mobile"
                  value={formData.mobile}
                  disabled
                  readOnly
                />
              </div>

              {/* Name */}
              <div className='form-lable-input'>
                <label>{t("p_name")}</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* DOB */}
              <div className='form-lable-input'>
                <label>{t("p_dob")}</label>
                <input
                  type="date"
                  name="dob"
                  value={formData.dob}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Age */}
              <div className='form-lable-input'>
                <label>Age</label>
                <input
                  type="number"
                  name="age"
                  value={formData.age}
                  readOnly
                />
              </div>

              {/* Gender */}
              <FormControl component="fieldset">
                <FormLabel
                  component="legend"
                  sx={{ padding: '15px 0px 0px 0px', color: '#111' }}
                >
                  <b>{t("p_gender")}</b>
                </FormLabel>

                <RadioGroup
                  row
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="male"
                    control={<Radio />}
                    label={t("p_male")}
                  />
                  <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label={t("p_female")}
                  />
                  <FormControlLabel
                    value="other"
                    control={<Radio />}
                    label={t("p_other")}
                  />
                </RadioGroup>
              </FormControl>

              {/* Address */}
              <div className='form-lable-input'>
                <label>{t("p_address")}</label>
                <textarea
                  name="locationValue"
                  value={formData.locationValue}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Village */}
              <div className='form-lable-input'>
                <label>Village</label>
                <input
                  type="text"
                  name="village"
                  value={formData.village}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* District */}
              <div className='form-lable-input'>
                <label>District</label>
                <input
                  type="text"
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className='psubmit'>
                <Link
                  component={RouterLink}
                  to="/disclaimer"
                  className='psubmit-back'
                >
                  {t('back_btn')}
                </Link>

                <Link
                  component="button"
                  sx={{ marginTop: '30px' }}
                  onClick={async () => {
                    try {
                      await axios.post(
                        "/api/updateUser_reg_complete",
                        {
                          phone: receivedNumber,
                          page_state: mode,
                          name: formData.name,
                          dob: formData.dob,
                          age: formData.age,
                          gender: formData.gender,
                          address: formData.locationValue,
                          village: formData.village,
                          district: formData.district
                        },
                        { timeout: 10000 }
                      );

                      navigate("/chatbot", {
                        state: {
                          number: receivedNumber,
                          name: formData.name,
                          dob: formData.dob,
                          age: formData.age,
                          gender: formData.gender,
                          address: formData.locationValue,
                          village: formData.village,
                          district: formData.district
                        }
                      });

                    } catch (err) {
                      console.error(err);
                      alert("Something went wrong");
                    }
                  }}
                >
                  {t('start_chat')}
                </Link>
              </div>

            </form>
          </div>
        </div>
      </Toolbar>
    </Box>
  );
};

export default Pform;